/* 🤖 this file was generated by svg-to-ts */
export const matIconShortText: {
  name: 'short-text';
  data: string;
} = {
  name: 'short-text',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 9h16v2H4V9zm0 4h10v2H4v-2z"/></svg>`
};
